import { OnboardingFlowRevision, PublishOnboardingFlowInput } from '../../onboarding.js';
export const adminOnboardingRoutes = {
    publishOnboardingFlow: {
        method: 'POST',
        path: '/admin/onboarding/flow/publish',
        body: PublishOnboardingFlowInput,
        response: OnboardingFlowRevision,
    },
};
//# sourceMappingURL=routes.js.map